<template>
  <div class="answer-upload-container">
    <div class="answer-upload-content">
      <!-- 科技成果评价问答部分 -->
      <div class="answer-section">
        <div class="section-header">
          <div class="section-title"><div class="line"></div>科技成果评价问答</div>
          <div href="/answer" class="more-link" @click="handleClick(1)">更多<i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="answer-content">
          <div class="answer-bg">
            <img src="../assets/image/answer.png" alt="">
          </div>
          <div class="answer-list">
            <div class="answer-column">
              <div class="answer-item" v-for="(item,index) in answerList.slice(0,5)" :key="index" @click="handleAnswerClick(item)">
                <span :class="index==0?'first-item':index==1?'second-item':index==2?'third-item':'other-item'">{{ index+1 }}</span> {{ item.title }}
              </div>
            </div>
            <div class="answer-column">
              <div class="answer-item" v-for="(item,index) in answerList.slice(5,10)" :key="index" @click="handleAnswerClick(item)">
                <span class="other-item">{{ index+6 }}</span> {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 评价资料下载区部分 -->
      <div class="upload-section">
        <div class="section-header">
          <div class="section-title"><div class="line"></div>评价资料下载区</div>
          <div href="/download" class="more-link" @click="handleClick(2)">更多<i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="upload-content">
          <div class="upload-bg">
            <img src="../assets/image/download.png" alt="">
          </div>
          <div class="download-list">
            <div class="download-item" v-for="(item,index) in downloadList" :key="index" @click="downlaod(item)">
              <div class="u-flex u-gap-6">
                <img src="../assets/image/file.png" alt="">
                <div class="download-file">
                  <span class="file-name">{{ item.title }}</span>
                  <span class="file-size">{{item.file_size}}</span>
                </div>
              </div>
              <button class="download-btn"><i class="el-icon-download"></i> 下载</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { evaluateAnswer, evaluationMaterials } from '@/api/index'
import { httphosts } from '@/utils/global'

export default {
  name: 'AnswerUpload',
  data() {
    return {
      // 可以在这里添加数据
      answerList: [],
      downloadList: []
    }
  },
  mounted() {
    this.evaluateAnswer()
    this.evaluationMaterials()
  },
  watch: {
    '$route': {
      handler() {
        // 当路由变化时，重新加载数据
        this.evaluateAnswer()
        this.evaluationMaterials()
      }
    }
  },
  methods: {
    // 评价科技成果
    evaluateAnswer() {
      evaluateAnswer({
        page: 1,
        limit: 10
      }).then(res => {
        if (res.code === 1) {
          this.answerList = res.data.list
        }
      })
    },
    // 评价资料下载
    evaluationMaterials() {
      evaluationMaterials({
        page: 1,
        limit: 4
      }).then(res => {
        if (res.code === 1) {
          this.downloadList = res.data.list
        }
      })
    },
    // 点击问答项跳转详情页
    handleAnswerClick(item) {
      this.$router.push({path: '/answerDetails', query: { id: item.id }}).catch(() => { })
    },
    // 可以在这里添加方法
    handleClick(index) {
      if(index==1){
        this.$router.push({path: '/answer'}).catch(() => { })
      }else if(index==2){
        this.$router.push({path: '/download'}).catch(() => { })
      }
    },
    downlaod(item) {
      // 直接下载文件到本地
      const link = document.createElement('a')
      link.href = httphosts + item.file_path
      link.download = item.title
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.answer-upload-container {
  padding: 40px 0;
  width: 100%;
}

.answer-upload-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
  width: 100%;
}

/* 通用部分样式 */
.answer-section,
.upload-section {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
  display: flex;
  align-items: center;
}
.line {
  width: 5px;
  height: 18px;
  background: #1B5AFF;
  margin-right: 8px;
}

.more-link {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  cursor: pointer;
}

.more-link:hover {
  color: #0066cc;
}

/* 科技成果评价问答部分样式 */
.answer-content {
  padding: 20px;
}

.answer-bg {
  /* background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 8px;
  padding: 40px; */
  margin-bottom: 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.answer-bg::after {
  content: '';
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 120px;
  height: 120px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2390caf9"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/></svg>');
  background-repeat: no-repeat;
  background-size: contain;
}

.answer-text h4 {
  font-size: 18px;
  font-weight: bold;
  color: #1a365d;
  margin: 8px 0;
}

.answer-list {
  display: flex;
  gap: 40px;
}

.answer-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.answer-item {
  font-size: 14px;
  color: #333;
  line-height: 32px;
  cursor: pointer;
  transition: color 0.3s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answer-item:hover {
  color: #0066cc;
}
.first-item {
  font-size: 14px;
  color: #FF0B34;
}
.second-item {
  font-size: 14px;
  color: #FF6600;
}
.third-item {
  font-size: 14px;
  color: #FCC633;
}
.other-item {
  font-size: 14px;
  color: #999;
}


/* 评价资料下载区部分样式 */
.upload-content {
  padding: 20px;
}

.upload-bg {
  /* background: linear-gradient(135deg, #bbdefb 0%, #90caf9 100%);
  border-radius: 8px;
  padding: 40px; */
  margin-bottom: 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.upload-bg::after {
  content: '';
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 120px;
  height: 120px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2364b5f6"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"/></svg>');
  background-repeat: no-repeat;
  background-size: contain;
}

.upload-text h4 {
  font-size: 18px;
  font-weight: bold;
  color: #1a365d;
  margin: 8px 0;
}

.download-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.download-item {
  position: relative;
  width: calc(50% - 10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 4px;
  height: 88px;
  background: #F9FBFF;
  border: 1px dashed #E0E0E0;
  cursor: pointer;
  transition: all 0.3s ease;
}
.download-item:hover {
  transform: translateY(-3px);
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
}
.download-file {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #999;
}

.download-btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
  padding: 6px 12px;
  background-color: transparent;
  color: #0066cc;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-btn:hover {
  /* background-color: #0052a3; */
  color: #F66F00;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .answer-upload-content {
    flex-direction: column;
  }
  
  .answer-row {
    flex-direction: column;
    gap: 8px;
  }
  
  .answer-bg,
  .upload-bg {
    padding: 20px;
  }
  
  .answer-bg::after,
  .upload-bg::after {
    width: 80px;
    height: 80px;
  }
}
</style>